<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">This book is dedicated to the memory of Frank Rollins, Jr. (1918–1998)</p>
<p class="ded">He shared with all his gift of laughter and so enriched the years we lived.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?9fe6fbc8